import React from "react";

const BusinessSubscription = () => {
  return <div>BusinessSubscription</div>;
};

export default BusinessSubscription;
